import { Selector, State } from "./types";
import { projectConfiguration } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    getProjectToolsConfiguration(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.configuration : projectConfiguration;
    },
    isRetrieveProjectToolsConfigurationRequestFailure(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isRetrieveProjectToolsConfigurationRequestPending(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isRetrieveProjectToolsConfigurationRequestSuccess(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
